// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
export enum WeatherTypes {
	Unknown = 0,
	Rain = 1,
	Fog = 2,
	Sunny = 4,
	Cloudy = 8,
	Snow = 16,
	SunGlare = 512,
}

export const WeatherTypesDisplayNames: { [key in keyof typeof WeatherTypes]?: string} = {
	"Unknown": "Unknown",
	0 : "Unknown",
	"Rain": "Rain",
	1 : "Rain",
	"Fog": "Fog",
	2 : "Fog",
	"Sunny": "Sunny",
	4 : "Sunny",
	"Cloudy": "Cloudy",
	8 : "Cloudy",
	"Snow": "Snow",
	16 : "Snow",
	"SunGlare": "Sun Glare",
	512 : "Sun Glare",
}

export const getWeatherTypesDisplayName = (key: WeatherTypes | number |  (keyof typeof WeatherTypes & string)) => {
	if (isNaN(+key)) return WeatherTypesDisplayNames[key];
	return Object.keys(WeatherTypesDisplayNames).filter(v => parseInt(v) >= 0 && (parseInt(v) & Number(key)) > 0).map(v => WeatherTypesDisplayNames[v as (keyof typeof WeatherTypes)]).join(', ');
}

